module.exports = __webpack_public_path__ + "img/blocHundai.eec6db4e.png";